const isSSL = (location.hostname == 'localhost')? 'http': 'https';
const connection = io.connect(`${isSSL}://${location.hostname}:4000/`);

module.exports = {
	connection
}
